package `fun`.adaptive.cookbook

import `fun`.adaptive.resource.file.Files
import `fun`.adaptive.resource.file.FileResource
import `fun`.adaptive.resource.file.FileResourceSet

private object commonMainFile0 {

    val index by lazy { init_index() }

    val policy by lazy { init_policy() }

    val terms by lazy { init_terms() }

}

val Files.index
    get() = commonMainFile0.index

private fun init_index() =
    FileResourceSet(
        name = "index",
        FileResource("/fun.adaptive.cookbook/files/index.html", setOf())
    )

val Files.policy
    get() = commonMainFile0.policy

private fun init_policy() =
    FileResourceSet(
        name = "policy",
        FileResource("/fun.adaptive.cookbook/files/policy.txt", setOf())
    )

val Files.terms
    get() = commonMainFile0.terms

private fun init_terms() =
    FileResourceSet(
        name = "terms",
        FileResource("/fun.adaptive.cookbook/files/terms.txt", setOf())
    )